import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const Results = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const response = await api.get('/results');
        setResults(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching results:', error);
        // Fallback to mock data if API fails
        setResults([
          {
            id: 1,
            studentName: 'John Doe',
            roll: '101',
            class: 'Grade 10',
            section: 'A',
            exam: 'Final Exam 2023',
            totalMarks: 850,
            obtainedMarks: 720,
            percentage: 84.7,
            grade: 'A',
            date: '2023-12-15'
          },
          {
            id: 2,
            studentName: 'Jane Smith',
            roll: '102',
            class: 'Grade 10',
            section: 'A',
            exam: 'Final Exam 2023',
            totalMarks: 850,
            obtainedMarks: 780,
            percentage: 91.8,
            grade: 'A+',
            date: '2023-12-15'
          },
          {
            id: 3,
            studentName: 'Robert Johnson',
            roll: '103',
            class: 'Grade 9',
            section: 'B',
            exam: 'Mid Term 2023',
            totalMarks: 600,
            obtainedMarks: 520,
            percentage: 86.7,
            grade: 'A',
            date: '2023-11-10'
          }
        ]);
        setLoading(false);
      }
    };

    fetchResults();
  }, []);

  const classes = ['All', 'Nursery', 'KG', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'];

  const filteredResults = results.filter(result => {
    const matchesSearch = result.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         result.roll.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesClass = selectedClass === 'All' || result.class === selectedClass;
    return matchesSearch && matchesClass;
  });

  return (
    <div className="min-h-screen py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">Results</h1>
        
        {/* Search and Filter Section */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label className="block text-gray-700 mb-2">Search by Name or Roll</label>
              <input
                type="text"
                placeholder="Enter name or roll number"
                className="w-full p-2 border rounded"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-2">Select Class</label>
              <select
                className="w-full p-2 border rounded"
                value={selectedClass}
                onChange={(e) => setSelectedClass(e.target.value)}
              >
                {classes.map(cls => (
                  <option key={cls} value={cls}>{cls}</option>
                ))}
              </select>
            </div>
            <div className="flex items-end">
              <button className="w-full bg-primary text-white px-4 py-2 rounded hover:bg-blue-700">
                Search Results
              </button>
            </div>
          </div>
        </div>

        {/* Results Table */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Student Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Roll</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Class</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Exam</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Percentage</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Grade</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredResults.length > 0 ? (
                  filteredResults.map((result) => (
                    <tr key={result.id}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{result.studentName}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{result.roll}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{result.class}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{result.exam}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{result.percentage}%</td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          result.grade === 'A+' || result.grade === 'A' ? 'bg-green-100 text-green-800' :
                          result.grade === 'B' ? 'bg-yellow-100 text-yellow-800' :
                          'bg-red-100 text-red-800'
                        }`}>
                          {result.grade}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{result.date}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <button className="text-primary hover:underline mr-3">View</button>
                        <button className="text-green-600 hover:underline">Download</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="px-6 py-4 text-center text-gray-500">No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* How to Check Result */}
        <div className="mt-8 bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">How to Check Your Result</h2>
          <ol className="list-decimal pl-6 space-y-2">
            <li>Enter your roll number in the search box above</li>
            <li>Select your class from the dropdown menu</li>
            <li>Click on the "Search Results" button</li>
            <li>Your result will appear in the table</li>
            <li>Click "View" to see detailed result or "Download" to get a PDF copy</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Results;